<div class="d-flex align-items-center justify-content-between">
  <input (change)="uploadFile($event)" [placeholder]="url" [required]="required"
         fullWidth nbInput shape="rectangle" status="info" type="file">
  <a *ngIf="url" [href]="url" class="m-2" target="_blank">
    VIEW
  </a>

</div>
